(function () {
  var container = document.getElementById('{{ section.id }}') || document;

  function showToast(message) {
    var t = document.createElement('div');
    t.className = 'sct-toast';
    t.innerText = message;
    Object.assign(t.style, {
      position: 'fixed', right: '20px', bottom: '20px', zIndex: 9999,
      padding: '10px 14px', background: '#222', color: '#fff', borderRadius: '6px',
      fontFamily: 'Nunito, system-ui, sans-serif'
    });
    document.body.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; t.style.transition = 'opacity 400ms ease'; }, 2000);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 2400);
  }

  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (cart) {
        var el = document.querySelector('.site-cart-count');
        if (el) el.innerText = cart.item_count || 0;
      })
      .catch(function () { /* ignore */ });
  }

  container.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart-btn');
    if (!btn) return;

    // Immediately stop other handlers and navigation attempts
    try { e.preventDefault(); } catch (err) {}
    try { e.stopPropagation(); } catch (err) {}
    try { e.stopImmediatePropagation(); } catch (err) {}

    // Also if button lives inside an anchor, prevent that anchor's default explicitly
    var outerAnchor = btn.closest('a');
    if (outerAnchor) {
      try {
        // prevent navigation for this click
        outerAnchor.addEventListener('click', function stopNav(ev) { ev.preventDefault(); ev.stopPropagation(); }, { once: true, capture: true });
      } catch (err) {}
    }

    // guard: sold-out or already adding
    if (btn.classList.contains('sold-out') || btn.getAttribute('aria-disabled') === 'true' || btn.dataset.adding === 'true') {
      return;
    }

    // find variant id (supports GID like "gid://shopify/ProductVariant/12345" or plain "12345")
    var variantRaw = btn.getAttribute('data-variant-id') || btn.dataset.variantId || '';
    var variantId = null;
    if (variantRaw) {
      var m = variantRaw.toString().match(/(\d+)$/);
      if (m) variantId = parseInt(m[1], 10);
    }

    // fallback to product page if variant not found (explicit and logged)
    if (!variantId) {
      var fallbackUrl = btn.getAttribute('data-product-url') || (outerAnchor && outerAnchor.getAttribute('href')) || window.location.href;
      window.location.href = fallbackUrl;
      return;
    }

    // set adding state (prevent double clicks)
    btn.dataset.adding = 'true';
    btn.setAttribute('aria-disabled', 'true');
    btn.style.pointerEvents = 'none';

    // preserve original text and lock visual width
    var textEl = btn.querySelector('.btn-text') || btn;
    var originalText = (textEl && textEl.innerText) ? textEl.innerText : 'Add To Cart';
    var rect = btn.getBoundingClientRect();
    var lockWidth = Math.round(rect.width);
    btn.style.minWidth = lockWidth + 'px';
    btn.style.width = lockWidth + 'px';
    btn.style.transition = 'width 120ms ease';

    if (textEl) textEl.innerText = 'Adding...';

    // perform add
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
      credentials: 'same-origin'
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (j) { throw j; });
      return res.json();
    })
    .then(function (json) {
      showToast('Added to cart');
      if (textEl) textEl.innerText = 'Added';

      // update cart count if theme uses .site-cart-count
      updateCartCount();

      // release and restore after short delay
      setTimeout(function () {
        if (textEl) textEl.innerText = originalText;
        btn.removeAttribute('aria-disabled');
        btn.style.pointerEvents = '';
        btn.dataset.adding = '';
        btn.style.width = '';
        btn.style.minWidth = '';
      }, 1200);

      // OPTIONALLY: dispatch a custom event so theme/apps can open drawer intentionally
      // var ev = new CustomEvent('sibt:add-to-cart-success', { detail: json });
      // window.dispatchEvent(ev);
    })
    .catch(function (err) {
      showToast('Could not add to cart');
      if (textEl) textEl.innerText = originalText;
      btn.removeAttribute('aria-disabled');
      btn.style.pointerEvents = '';
      btn.dataset.adding = '';
      btn.style.width = '';
      btn.style.minWidth = '';
    });

  }, false);

})();
